import React, { createContext } from 'react';
import { compose, difference, omit, filter } from 'ramda';
import * as ReactDOM from 'react-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { set } from '@synergycms_core/utils';
import styleFile from './popoverProvider.js';
import connect from 'react-redux/es/connect/connect';
import RichText from '@synergycms_core/components/generic/RichText';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';

// noinspection JSUnusedLocalSymbols
const { Consumer, Provider } = createContext({});

export const showPopover = Child => {
  return class extends React.Component {
    static displayName = 'popoverProvider(' + Child.displayName + ')';
    render() {
      return (
        <Consumer>
          {popover => <Child {...this.props} toggleModal={popover.toggleModal} closeByFamily={popover.closeByFamily} />}
        </Consumer>
      );
    }
  };
};

class PopoverProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popovers: []
    };
    this.toggleModal = this.toggleModal.bind(this);
  }
  static displayName = 'PopoverProvider';

  toggleModal = (show, code, popover, familyType, timeout = 300, forceCloseByFamily = false) => {
    this.setState(state => {
      if (!familyType || !forceCloseByFamily) {
        return {
          popovers: show
            ? set(code, { code: code, popover: popover, timeout: timeout }, state.popovers)
            : omit([code], state.popovers)
        };
      } else {
        const filtered = filter(popover => {
          return popover.familyType !== familyType;
        }, state.popovers);
        return {
          popovers: show
            ? set(code, { code: code, familyType: familyType, popover: popover, timeout: timeout }, filtered)
            : filtered
        };
      }
    });
  };

  closeByFamily = (familyType = 'tooltip', timeout = 0) => {
    if (
      Object.keys(this.state.popovers).length ||
      filter(popover => {
        return popover.familyType !== familyType;
      }, this.state.popovers)
    ) {
      this.toggleModal(false, null, null, familyType, timeout, true);
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    const oldIds = [];
    if (prevProps.notifications) {

      prevProps.notifications.forEach(notification => {
        oldIds.push(notification.get('id'));
      });

      const newIds = [];
      this.props.notifications.forEach(notification => {
        newIds.push(notification.get('id'));
      });

      const oldNotifications = difference(oldIds, newIds);
      const newNotifications = difference(newIds, oldIds);

      prevProps.notifications.forEach(notification => {
        if (oldNotifications.includes(notification.get('id'))) {
          this.toggleModal(
            false,
            `${notification.get('id')}-${notification.get('type')}`,
            <Notificator text={notification.get('text')} />
          );
        }
      });

      this.props.notifications.forEach(notification => {
        const type = notification.get('type'),
          id = notification.get('id');
        if (newNotifications.includes(id)) {
          this.toggleModal(true, `${id}-${type}`, <Notificator text={notification.get('text')} type={type} />);
        }
      });
    }
  };

  render() {
    const { children, theme } = this.props;
    const { popovers } = this.state;
    const { classes } = theme.styles;
    return (
      <React.Fragment>
        <Provider
          value={{
            toggleModal: this.toggleModal,
            closeByFamily: this.closeByFamily
          }}>
          {children}
          {ReactDOM.createPortal(
            <TransitionGroup>
              {Object.values(popovers).map(popup => {
                return (
                  <CSSTransition
                    enter={true}
                    exit={true}
                    key={popup.code}
                    timeout={popup.timeout}
                    classNames={{
                      enter: classes.enter,
                      enterActive: classes.enterActive,
                      exit: classes.leave,
                      exitActive: classes.leaveActive
                    }}>
                    {popup.popover}
                  </CSSTransition>
                );
              })}
            </TransitionGroup>,
            document.body
          )}
        </Provider>
      </React.Fragment>
    );
  }
}

const Notificator = compose(withThemeJSS({ styleFile: styleFile.notification, displayName: 'Notificator' }))(props => {
  const { classes } = props.theme.styles;
  return (
    <div className={classes.notificationContainer}>
      <div className={classes[props.type + 'Notification']}>
        <RichText ucFirst={true} text={props.text} translate={true} />
      </div>
    </div>
  );
});

const mapStateToProps = (store, ownProps) => {
  return {
    notifications: store.get('notifications')
  };
};

export default compose(
  connect(mapStateToProps),
  withThemeJSS({ styleFile: styleFile.popoverProvider })
)(PopoverProvider);
